/**
 * AgentWorkspaceSelector — the workspace line under the "PRATUS AI Agent"
 * header. Display-only: it shows the agent's current scope — the active
 * incident workspace, or the org-wide workspace when no incident is bound.
 * Switching workspaces happens through the normal app surfaces (hamburger menu,
 * incident cards, etc.); new agent chats bind to whatever this line shows.
 */
import React from 'react';
import {
  selectGroup,
  selectIncident,
  useAppSelector,
} from 'slices/commonSelectors';

const AgentWorkspaceSelector: React.FC = () => {
  const incident = useAppSelector(selectIncident);
  const group = useAppSelector(selectGroup);

  const label = incident?.id
    ? incident.name
    : group?.group_name
      ? `${group.group_name} (Org)`
      : 'Org workspace';

  return (
    <div className="sidebar-workspace-label" title={label}>
      {label}
    </div>
  );
};

export default AgentWorkspaceSelector;
